module.exports = __webpack_public_path__ + "static/media/banner-2.ddf7d682.svg";